import QueryLink from './QueryLink';

const SignInLink = QueryLink({ modal: 'signin' });

export default SignInLink;
